var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/sort-by") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.61795884,10.1039448 L2.66475244,10.0516073 L6.60225244,6.16271845 C6.80502466,5.96244959 7.12409213,5.94704429 7.34475594,6.11650256 L7.39774756,6.16271845 L11.3352476,10.0516073 C11.5549175,10.2685653 11.5549175,10.6203236 11.3352476,10.8372815 C11.1324753,11.0375504 10.8134079,11.0529557 10.5927441,10.8834974 L10.5397524,10.8372815 L7.562,7.898 L7.5625,13.58125 C7.5625,13.8125192 7.31066017,14 7,14 C6.71152984,14 6.47377722,13.8383457 6.44128435,13.6300851 L6.4375,13.58125 L6.437,7.897 L3.46024756,10.8372815 C3.25747534,11.0375504 2.93840787,11.0529557 2.71774406,10.8834974 L2.66475244,10.8372815 C2.46198021,10.6370127 2.44638234,10.3218843 2.61795884,10.1039448 Z M12.6179588,13.8960552 L12.6647524,13.9483927 L16.6022524,17.8372815 C16.8050247,18.0375504 17.1240921,18.0529557 17.3447559,17.8834974 L17.3977476,17.8372815 L21.3352476,13.9483927 C21.5549175,13.7314347 21.5549175,13.3796764 21.3352476,13.1627185 C21.1324753,12.9624496 20.8134079,12.9470443 20.5927441,13.1165026 L20.5397524,13.1627185 L17.562,16.103 L17.5625,10.48125 C17.5625,10.215463 17.3106602,10 17,10 C16.7115298,10 16.4737772,10.1857818 16.4412843,10.4251261 L16.4375,10.48125 L16.437,16.102 L13.4602476,13.1627185 C13.2574753,12.9624496 12.9384079,12.9470443 12.7177441,13.1165026 L12.6647524,13.1627185 C12.4619802,13.3629873 12.4463823,13.6781157 12.6179588,13.8960552 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/sort-by",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBy);
export default __webpack_public_path__ + "static/media/sort-by.0a7d544b02b457e9a7205bc90daeed91.svg";
export { ForwardRef as ReactComponent };